import React from "react";
import { Classes } from "@blueprintjs/core";
import css from "./auth.module.scss";
import classnames from "classnames";

const AppVersionFooter = ({ appVersion, env }: { appVersion?: string, env?: string }) => (
    <div className={classnames(css.appVersionFooter, Classes.TEXT_MUTED)}>
        {appVersion && <p>v{appVersion} ({env})</p>}
    </div>);

export default AppVersionFooter;
